import { Component, ElementRef, HostListener } from '@angular/core';
import { LoaderService } from './services/loader.service';

import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { AlertComponent } from './shared/components/alert/alert.component';
import { DialogService } from './services/dialog.service';
import { SafeHtmlPipe } from './pipes/safeHtml.pipe';
@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    imports: [CommonModule, RouterModule, AlertComponent, SafeHtmlPipe ]
})
export class AppComponent {
  title = 'Linkworx';
  constructor(private elementRef: ElementRef, public loaderService: LoaderService, public dialog: DialogService) {}
}
